export const is_iOS = (ua: string) => ua.match(/(iPad|iPhone|iPod)/g) !== null;
